import { flow, map, find } from "lodash/fp";
import constants from "../../core/constants";
import { mapGetIds } from "../../core/transforms";

import moment from "moment";
import { toObject } from "../../core/utils";

class PromotionPageTransform {
  constructor(Lists) {
    "ngInject";
    this.Lists = Lists.all;
    this.item = {
      title: "UserPromotion",
      state: "userpromotion",
      name: "userpromotion",
    };
    this.userPromotionFields = [{ title: "User", name: "user" }];
    this.addOptions = {
      title: "Add Customer",
      icon: "add",
      fields: [
        {
          isResourceList: true,
          items: [],
          resource: "User",
          name: "users",
          formatter: mapGetIds,
          title: "Customer",
        },
      ],
    };
  }

  justify(data) {
    const format = (item) => {
      const findPromoSegment = (l) => item.segment === l.name;
      const findPromoRenewalValue = (l) => item.renewal === l.name;
      item.segment = find(findPromoSegment)(this.Lists.promoSegments);
      item.renewal = find(findPromoRenewalValue)(this.Lists.renewalValues);
      return item;
    };
    const setRideName = (item) => {
      item.name =
        item.route.name +
        " " +
        moment(item.date).format(constants.dateTimeFormat);

      return item;
    };
    const formatDate = (item) => {
      item.start_date = item.start_date
        ? moment(item.start_date).format(constants.dateTimeFormat)
        : null;
      item.end_date = item.end_date
        ? moment(item.end_date).format(constants.dateTimeFormat)
        : null;

      return item;
    };

    const formatObjs = (item) => {
      item.cities = toObject(item.cities);
      item.routes = toObject(item.routes);
      item.users = toObject(item.users);
      item.pick_ups = toObject(item.pick_ups);
      item.drop_offs = toObject(item.drop_offs);

      return item;
    };
    const formatPromotionValue = (item) => {
      item.promotionValue = {
        maximum: item.maximum,
        off: item.off,
        percentage: item.percentage,
        display_to_users: item.display_to_users,
        value: item.value,
        times: item.times,
        isDisabled: true,
      };

      return item;
    };

    const formatRides = (item) => {
      item.rides = toObject(map(setRideName)(item.rides));

      return item;
    };

    return toObject(
      flow([format, formatDate, formatObjs, formatRides, formatPromotionValue])(
        data
      )
    );
  }
}

export default PromotionPageTransform;



// WEBPACK FOOTER //
// ./src/pages/promotion/promotion.transforms.js